import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useFeaturebaseScript } from 'shared/hooks/use-featurebase-script';
import { connectionHelper } from 'shared/services/backend-api/helpers/connection-helper';
import { initElectronCommunication } from 'shared/services/electron';
import { init as initErrorTracking } from 'shared/services/error-tracking';
import { initServiceWorker } from 'shared/utils/init-service-worker';

export const AppWrapper: React.FC = () => {
  useFeaturebaseScript();

  useEffect(() => {
    connectionHelper();
    initErrorTracking();
    // electron communication
    initElectronCommunication();
    initServiceWorker();
  }, []);

  return <Outlet />;
};
